if($('.type-detail').length){
    if(!$('#simple-variants').length){
        if($('.variant-list, .surcharge-list').length>0){
            $('.variant-list select, .surcharge-list select').each(function(){
                if($(this).closest('.surcharge-list').find('th .show-tooltip').length){
                    var listTootip = $(this).closest('.surcharge-list').find('th .show-tooltip').attr('title')
                }
                else{
                    listTootip = ''
                }
                var optionLength = $(this).find('option').length
                var data_parameter_id = $(this).data('parameter-id')
                var html_var = '<div class="custom-variant" data-groupId="'+data_parameter_id+'">'
                html_var += '<div class="custom-variant-wrap" data-param-id="'+data_parameter_id+'">'
                $(this).find('option').each(function(){
                    var data_value = $(this).attr('value')
                    if($(this).closest('td').find('select[name*="parameterValueId"]').length){
                        if ($.isNumeric($(this).val())) {
                            var textsplit = $(this).text().split('+')
                            html_var += '<div class="variant haveVariant" data-value="'+data_value+'" data-parameter-id="'+data_parameter_id+'" data-param-val="'+data_parameter_id+'-'+data_value+'">'
                            html_var += '<div class="text">'
                            if(typeof textsplit[1] === 'undefined'){
                                html_var += textsplit[0]
                            }
                            else{
                                html_var += textsplit[0]+' (+'+textsplit[1]+')'
                            }
                          
                            if(listTootip !== ''){
                                if(textsplit[1] !== '0 Kč'){
                                    html_var += '<span class="show-tooltip question-tooltip" title="'+listTootip+'">?</span>'
                                }
                            }
                            html_var += '</div>'
                            html_var += '</div>'
                        }
                    }
                    else{
                        if ($.isNumeric($(this).val())) {
                            var textsplit = $(this).text().split('+')
                            html_var += '<div class="variant haveSurcharge show-tooltip" title="'+$(this).text()+'" data-value="'+data_value+'" data-parameter-id="'+data_parameter_id+'" data-param-val="'+data_parameter_id+'-'+data_value+'">'
                            html_var += '<div class="text">'+textsplit+'</div>'
                            html_var += '</div>'
                        }
                    }
                    
                })
                html_var += '</div>'
                html_var += '</div>'
                $(this).after(html_var)
                $(this).closest('.variant-list select, .surcharge-list select').hide()
               $(this).closest('.variant-list span, .surcharge-list span').hide()
              
            })
    
            var necessaryVariantData = shoptet.variantsSplit.necessaryVariantData;
            for (var parentKey in necessaryVariantData) {
                if (necessaryVariantData.hasOwnProperty(parentKey)) {
                    var variant = necessaryVariantData[parentKey];
                    $('.custom-variant-wrap .variant[data-param-val="'+parentKey+'"]').addClass('haveImage').attr('data-not-sold-out', variant.isNotSoldOut).attr('data-price-id', variant.id).attr('data-avail', variant.availabilityName.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/ /g, '-'))
                
                }
            }
            
        }
    }
    

    $(document).on('click', '.custom-variant-wrap .variant', function(){
        const variantData = $(this).data('value');
        const variantParameterId = $(this).data('parameter-id');
            $("select[data-parameter-id='"+variantParameterId+"'] option").filter(function (){
                return $(this).attr('value') == variantData;
            }).change().prop("selected", true);
            $(this).closest('.custom-variant-wrap[data-param-id="'+variantParameterId+'"]').find(".variant:not([data-value='"+variantData+"'])").removeClass("active");
            $(this).addClass("active"); 
        
    
        var selector = '.variant-list .hidden-split-parameter, .variant-list .split-parameter';
        var $splitParameters = $(selector);
        $splitParameters.trigger('change');
    
        $("select[data-parameter-id='"+variantParameterId+"']")[0].dispatchEvent(new Event('change'));
    
        $('.custom-variant-wrap .variant').each(function(){
            const variantData = $(this).data('value');
            const variantParameterId = $(this).data('parameter-id');
            const unavailable = $("select[data-parameter-id='"+variantParameterId+"'] option[value='" + variantData + "']").hasClass("unavailable-option");
            if (unavailable === true) {
                $(this).addClass("unavailable").removeClass("active");
            }
            else{
                $(this).removeClass("unavailable");
            } 
        });
    });

    $(document).on('click', '#jsUnavailableCombinationMessage a', function(){
        $('.custom-variant-wrap .variant').removeClass('unavailable')
    })
    $(document).ready(function(){
        $(".custom-variant-wrap").each(function() {
            var $variants = $(this).find("div.variant");
            if ($variants.length === 1) {
             $variants.addClass("active");
            }
          });
        var urlParams = new URLSearchParams(window.location.search);
        var parameterValueId = urlParams.get("parameterValueId");
        var $divToHighlight = $("div.variant[data-value='" + parameterValueId + "']");
        if ($divToHighlight.length > 0) {
            $divToHighlight.addClass("active");
        }
    })
    $(document).ready(function(){
        if($('.responsive-nav').length){
            if($('#p-detail-tabs').length){
                $('#p-detail-tabs').append($('.hidden-links').html())
            }
        }
    })

    $(document).ready(function () {
        var textFriends = 'KAMARAD'
        if($('table.detail-parameters tbody tr th').text().includes(textFriends)){
            var apiUrl = "https://friends.shopcode.cz/api.php";
            var section = "mikemoda";
            var codes = [];
            $('table.detail-parameters tbody tr').each(function () {
                var headerText = $(this).find('th span.row-header-label').text().trim();
                var friendName = $(this).find('td').text().trim();
                if (headerText.includes(textFriends)) {
                    $(this).closest('tr').hide()
                    codes.push(friendName);
                }
            });
            if (codes.length === 0) {
                console.warn("Žádné hodnoty "+textFriends+" nebyly nalezeny.");
                return;
            }
            $.ajax({
                url: apiUrl + "?section=" + section + "&codes=" + codes.join(","),
                type: "GET",
                dataType: "json",
                success: function (response) {
                    console.log(response.length)
                    $(".p-data-wrapper #product-detail-form").prepend('<div class="friendsSection"><div class="h5">Barevná varianta</div><div class="inner"></div></div>');
                   // $(".p-info-wrapper .friendsSection").empty();
                   var usedUrls = new Set();
                    response.forEach(function (item) {
                        var itemUrl =item.url.split('?variantId')[0]
                        if (document.location.pathname === itemUrl) {
                           var customClass = 'active'
                        }
                        else{
                            var customClass = '' 
                        }
                        
                       
                        
                        if (!usedUrls.has(itemUrl)) {
                            usedUrls.add(itemUrl);
                            var detailHtml = `
                            <div class="friend ${customClass} show-tooltip" data-title="${item.name.split('-')[0]}" data-original-title="${item.name.split('-')[0]}">
                                <div class="p">
                                    <div class="image">
                                        <a href="${itemUrl}">
                                            <img src="${item.image.replace('/orig/', '/detail/').split('.cz')[1]}" alt="${item.name.split('-')[0]}">
                                        </a>
                                    </div>
                                </div>
                            </div>
                            `;
                            $(".p-data-wrapper .friendsSection .inner").append(detailHtml);
                        }
                    });
                },
                error: function (xhr, status, error) {
                    console.error("Chyba při načítání API:", status, error);
                }
            }).done(function(){
                initTooltips();
            });
        }
        
    });
}